module.exports = __webpack_public_path__ + "static/media/waterfall-lit-up.032743f6.jpeg";